export default "__VITE_ASSET__Xdy7wND6__"